import Axios from "axios";
import server from "../statics/server";

export default {
	methods: {
		getLecInfo: async function(lecId) {
			const { data } = await Axios.post(`${server.addr()}${server.api.LECTURE}/${lecId}`, {});
			return data.return;
		},

		getCurriculumInfo: async function(curriculumId) {
			const { data } = await Axios.post(`${server.addr()}${server.api.CURRICULUM}/${curriculumId}`, {});
			return data.return;
		},

		getBoardSideMenus: async function(lecId) {
			const { data } = await Axios.post(`${server.addr()}${server.api.BOARD}`, { lecId })
			const { boardId } = this.$route.params;
			const sideMenus = data.list.map(e => {
				if(e.boardId === parseInt(boardId)) this.selectedBoard = e;
				return {
					board: e,
					selected: e.boardId === parseInt(boardId),
					name: e.boardName,
					link: `/classroom/${lecId}/board/${e.boardId}`
				}
			});
			if(!boardId) this.selectedBoard = data.list[0];

			return sideMenus;
		},

		getExamSideMenus: async (lecId) => {
			const { data } = await Axios.post(`${server.addr()}${server.api.CURRICULUM}`, { lecId });
			return data.list.map(c => {
				return {
					curriculumId: c.curriculumId,
					name: c.name,
					selected: false
				}
			})
		},

		getSurveySideMenus: async (lecId) => {
			const { data } = await Axios.post(`${server.addr()}${server.api.CURRICULUM}`, { lecId });
			return data.list.map(c => {
				return {
					curriculumId: c.curriculumId,
					name: c.name,
					selected: false
				}
			})
		}
	}
}